import {
  FlatTreeItem,
  FlatTreeItemProps,
  TreeItemLayout,
} from "@fluentui/react-components";
import { forwardRef } from "react";

export interface SimpleTreeItemProps extends FlatTreeItemProps {
  label: React.ReactNode;
}

const SimpleTreeItem = forwardRef<HTMLDivElement, SimpleTreeItemProps>(
  ({ label, ...props }, ref) => (
    <FlatTreeItem {...props} ref={ref}>
      <TreeItemLayout>{label}</TreeItemLayout>
    </FlatTreeItem>
  )
);

export default SimpleTreeItem;
